import React from 'react';
import LegalPage from './LegalPage';
import AvisoPrivacidadContent from '../components/legal/AvisoPrivacidadContent';

export default function AvisoPrivacidad() {
  return (
    <LegalPage
      eyebrow="documento legal"
      title="Aviso de privacidad integral"
      lastUpdate="5 de junio de 2026"
      activeSlug="aviso"
    >
      <AvisoPrivacidadContent />
    </LegalPage>
  );
}
